import React from 'react';

/**
 * Una sola petición HTTP por foto (<img>).
 * El Cache Storage + fetch extra saturaba el navegador (6 conexiones) y el hosting.
 * La 2ª visita la resuelve el caché HTTP si /imagenes manda max-age.
 */
export default function CachedProductImage({
  src,
  alt = '',
  className,
  style,
  loading = 'lazy',
  decoding = 'async',
  fetchPriority = 'auto',
  sizes,
  draggable = false,
  onLoad,
  onError,
}) {
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      decoding={decoding}
      fetchPriority={fetchPriority}
      sizes={sizes}
      draggable={draggable}
      onLoad={onLoad}
      onError={onError}
    />
  );
}
